<template>
	<div class="modal" v-if="loading">
		<div class="deletefile">
			<span @click="close" class="closefile">
				<img src="@/assets/Close Button.svg" />
			</span>
			<!--<div class="d-flex justify-content-center align-items-center mt-4">
                <img src="@/assets/trash-can.svg" />
            </div>-->
			<template v-if="!load">
				<div class="header d-flex justify-content-center align-items-center mt-2">
					<h6><strong>File name conflict</strong></h6>
				</div>
				<div class="cgn text-center my-2">
					<span>Compressed file will be renamed to <br /><strong>{{ new_name }}</strong></span>
				</div>
				<div class="save">
					<span class="btn-move-to-trash" @click="do_copy">
						Continue
					</span>

					<span class="btn-delete-permanently" @click="do_replace">
						Overwrite
					</span>
				</div>
			</template>
			<template v-else>
				<span class="load">
					<span>
						<svg width="80px" height="80px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
							preserveAspectRatio="xMidYMid" class="lds-dual-ring"
							style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
							<circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
								stroke-dasharray="31.41592653589793 31.41592653589793">
								<animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
									keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
							</circle>
						</svg>
					</span><br>
					<span>Please wait....</span>
				</span>
			</template>
		</div>
	</div>
</template>
<style scoped>
.header {
	padding: .5em 0 0 0 !important;
}

.header h3 {
	font-size: 22px;
	font-weight: bold;
}

.save {
	margin-top: 0 !important;
}

.cgn {
	display: flex;
	flex-direction: column;
}

.cgn span {
	margin-bottom: .4em;
	font-size: 14px;
}

.deletefile {
	padding: 2em !important;
}

.modal div.deletefile {
	width: 420px !important;
}

.modal div.deletefile div {
	width: 100% !important;
	margin-left: 0 !important;
}

.save {
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
}

.save span {
	flex: 1 !important;
}

.save .btn-move-to-trash {
	background: #3F96D1 !important;
	color: #fff !important;
	font-size: 13px !important;
}

.save .btn-delete-permanently {
	background: transparent !important;
	border: 1px solid #3F96D1 !important;
	font-size: 13px !important;
	color: #3F96D1 !important;
}

.save .btn-delete {
	background: transparent !important;
	border: 1px solid #3F96D1 !important;
	font-size: 13px !important;
	color: #3F96D1 !important;
}

.modal div.deletefile .closefile {
	top: 13px !important;
	right: 13px !important;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
export default {
	data() {
		return {
			wait: true,
			loading: false,
			done: false,
			load: false,
			new_name: '',
			id: null
		}
	},
	methods: {
		...mapMutations([
			'SET_FILE_ACTION',
			'REMOVE_FILE_ACTION',
			'SET_DIRECTORY_CHILDREN',
			'TOGGLE_FILE_INFO',
			'SORT_DIRECTORY_CHILDREN',
			'SORT_STORED_DIRECTORY_CHILDREN',
			'SET_STORED_DIRECTORY_CHILDREN',
			'SET_FILE_INFO_DATA',
			'SET_CURRENT_FILE_ID',
			'SET_CURRENT_DIRECTORY',
			'SET_PATH',
			'HIDE_FILE_INFO',
			'SET_FILE_INDEX',
			'SET_FILES_INDEX',
			'UPDATE_DIRECTORY_CHILDREN'
		]),
		str_text(str) {
			if (str.length > 24) {
				let fSeg = str.substring(0, 5)
				let sSeg = str.substr(str.length - 12, 7)

				return fSeg + '....' + sSeg
			}

			return str
		},
		loaderclose() {
			this.$parent.closeloader();
		},
		loaderbrowse() {
			this.$parent.browseloader();
		},
		logincall() {
			this.$parent.logincall();
		},
		loader(index, new_name) {
			this.loading = true;
			this.wait = true;
			this.load = false;
			this.new_name = new_name;
			this.done = false;
			this.index = index
			this.id = this.$store.getters.DIRECTORY_CHILDREN[index].id
		},
		do_replace() {
			if (this.id) {
				let that = this;

				let data = {
					id: this.id,
					token: cookies.getCookie('token'),
					replace: true
				};

				this.load = true
				this.folders = []

				this.$socket.emit('compress', data, function (data) {
					if (data.data === false) {
						that.loading = false
						that.load = false
						that.seen = false
						that.logincall()
					}

					if (data.data === true && data.message === 'completed') {
						that.load = false
						that.loading = false
					}
				});
			}
		},
		do_copy() {
			if (this.id) {
				let that = this;

				let data = {
					id: this.id,
					token: cookies.getCookie('token'),
					rename: true
				};

				this.load = true;
				this.folders = [];

				this.$socket.emit("compress", data, function (data) {
					if (data.data === false) {
						that.loading = false;
						that.load = false;
						that.seen = false
						that.logincall();
						that.$router.push('/login')
					}

					if (data.data === true && data.message === "completed") {
						that.load = false
						that.loading = false
						that.UPDATE_DIRECTORY_CHILDREN(data.directory_children)
						that.SORT_DIRECTORY_CHILDREN()
					}
				});
			}
		},
		close() {
			this.loading = false;
			this.wait = false;
		}
	}
}
</script>